import "../../App.css";
import { useState, useEffect } from "react";
import { Table, Select, Pagination } from "antd";
import axios from "axios";
import moment from "moment";
import Appconfig from "../../config/config";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import AccountSidebar from "components/AccountSidebar";

function BetHistory() {
  const userInfo = useSelector((state) => state?.userInfo?.userdata);

  const [filteredData, setFilteredData] = useState([]);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    user_id: userInfo && userInfo?._id,
    event_type: "4",
    from_date: moment().subtract(1, "days").format("YYYY-MM-DD"),
    to_date: moment().format("YYYY-MM-DD"),
    status: "Settled",
  });

  // *************** Calendar Logic ****************
  const [showFromCalendar, setShowFromCalendar] = useState(false);
  const [showToCalendar, setShowToCalendar] = useState(false);

  const handleFromDate = (newDate) => {
    if (newDate) {
      setFormData({ ...formData, from_date: newDate });
      setShowFromCalendar(false);
    }
  };

  const toggleFromCalendar = () => {
    setShowFromCalendar(!showFromCalendar);
    setShowToCalendar(false);
  };

  const handleToDate = (newDate) => {
    if (newDate) {
      setFormData({ ...formData, to_date: newDate });
      setShowToCalendar(false);
    }
  };

  const toggleToCalendar = () => {
    setShowToCalendar(!showToCalendar);
    setShowFromCalendar(false);
  };

  const formattedFromDate = formData.from_date
    ? format(new Date(formData.from_date), "dd-MM-yyyy")
    : format(new Date(), "dd-MM-yyyy");
  const formattedToDate = formData.to_date
    ? format(new Date(formData.to_date), "dd-MM-yyyy")
    : format(new Date(), "dd-MM-yyyy");

  // *************** Inputs Handlers ****************

  const onChangeBetStatus = (betstatus) => {
    setFormData({ ...formData, status: betstatus });
  };

  const onChangeSportType = (sporttype) => {
    setFormData({ ...formData, event_type: sporttype });
  };

  const onChangeDataType = (datatype) => {
    let newDate = moment().format("YYYY-MM-DD");
    if (datatype === "LIVE") {
      newDate = moment().format("YYYY-MM-DD");
    } else if (datatype === "BACKUP") {
      newDate = moment().subtract(3, "month").format("YYYY-MM-DD");
    } else if (datatype === "OLD") {
      newDate = moment().subtract(1, "year").format("YYYY-MM-DD");
    }
    setFormData({ ...formData, from_date: newDate });
  };

  const handlePageSizeChange = (e) => {
    setPageSize(e);
    setCurrent(1);
  };

  const handleFirst = () => setCurrent(1);
  const handleLast = () => setCurrent(Math.ceil((filteredData?.length || 0) / pageSize));

  const startIndex = (current - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedData = filteredData?.slice(startIndex, endIndex);

  useEffect(() => {
    filterBetHistory();
  }, []);

  const filterBetHistory = async () => {
    setLoading(true);
    var data = JSON.stringify(formData);
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}reports/aurafilterbetHistory`,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    axios(config)
      .then(function (response) {
        try {
          setFilteredData(response.data.resultData || []);
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  let locale = { emptyText: "No data!" };

  const SectionHeader = ({ title }) => (
    <div className='px-3 py-[2px] bg-[#7e97a7] text-white font-bold text-sm'>
      {title}
    </div>
  );

  const columns = [
    {
      title: "Sport Name",
      dataIndex: "name",
      sorter: true,
      width: 120,
      render: (_, record) => {
        let sportName = "Casino";
        if (record.event_type == 4) sportName = "Cricket";
        else if (record.event_type == 2) sportName = "Tennis";
        else if (record.event_type == 1) sportName = "Soccer";
        else if (record.event_type == 7) sportName = "Horse Racing";
        else if (record.event_type == 4339) sportName = "Greyhound Racing";
        else if (record.event_type == 27979456) sportName = "Kabaddi";
        else if (record.event_type == 7522) sportName = "Basketball";
        else if (record.event_type == 2378961) sportName = "Politics";
        else if (record.event_type == 66101) sportName = "Virtual";
        else if (record.event_type == 66104) sportName = "Lottery";
        else if (record.event_type == 777) sportName = "WCO Casino";

        return <span className="font-extrabold text-[#212529] text-[0.813rem]">{sportName}</span>
      },
    },
    {
      title: "Event Name",
      dataIndex: "event_name",
      sorter: true,
      width: 200,
      render: (_, record) => (
        <span className="font-extrabold text-[#212529] text-[0.813rem] ">
          {record?.event_type == 777 ? record?.game_code : record.event_name}
        </span>
      ),
    },
    {
      title: "Market name",
      dataIndex: "market_name",
      sorter: true,
      width: 150,
      render: (_, record) => (
        <span className="font-extrabold text-[#212529] text-[0.813rem] ">
          {record?.event_type == 777 ? record?.game_code : record.market_name}
        </span>
      ),
    },
    {
      title: "Selection",
      dataIndex: "runner_name",
      sorter: true,
      width: 150,
      render: (_, record) => (
        <span className="font-extrabold text-[#212529] text-[0.813rem] ">
          {record?.event_type == 777 ? '-' : record.runner_name}
        </span>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      sorter: true,
      width: 80,
      render: (_, record) => (
        record.event_type == "777" ? (
          <div className='font-extrabold text-[#212529] text-[0.813rem]'>{record?.transaction_type}</div>
        ) : record.is_back ? (
          <div className='font-extrabold text-[#212529] text-[0.813rem]'>BACK</div>
        ) : (
          <div className='font-extrabold text-[#212529] text-[0.813rem]'>Lay</div>
        )
      ),
    },
    {
      title: "Odds Req.",
      dataIndex: "price_val",
      sorter: false,
      width: 100,
      render: (_, record) => (
        <span className="font-extrabold text-[#212529] text-[0.813rem] ">
          {record?.event_type == 777 ? '-' : record.price_val}
        </span>
      ),
    },
    {
      title: "Stack",
      dataIndex: "stake",
      sorter: true,
      width: 100,
      render: (_, record) => (
        <span className="font-extrabold text-[#212529] text-[0.813rem] ">
          {record?.event_type == 777 ? record.amount : record.stake}
        </span>
      ),
    },
    {
      title: "Place Time",
      dataIndex: "createdAt",
      sorter: true,
      width: 150,
      render: (_, record) => (
        <span className="font-extrabold text-[#212529] text-[0.813rem] ">
          {new Date(record.createdAt).toLocaleString("en-GB", {
            day: "2-digit", month: "2-digit", year: "numeric",
            hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true,
          })}
        </span>
      ),
    },
    {
      title: "Matched Time",
      dataIndex: "updatedAt",
      sorter: true,
      width: 150,
      render: (_, record) => (
        <span className="font-extrabold text-[#212529] text-[0.813rem] ">
          {new Date(record.updatedAt).toLocaleString("en-GB", {
            day: "2-digit", month: "2-digit", year: "numeric",
            hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true,
          })}
        </span>
      ),
    },
  ];

  return (
    <div className="bg-[#eeeeee] min-h-screen font-sans pt-[60px] pb-[80px] lg:pt-0 lg:pb-0 overflow-x-hidden">
      {/* Container Fix:
          - w-full: Ensures it fits within parent
          - max-w-[1300px]: Prevents it from getting too wide on huge screens
          - mx-auto: Centers it
          - px-2 lg:px-4: Adds breathing room on sides so content doesn't touch edges
      */}
      <div className="w-full max-w-[1300px] mx-auto px-2 lg:px-4 flex flex-col lg:flex-row gap-4 items-start">

        {/* Left Sidebar - Fixed width on Desktop, Hidden on Mobile */}
        <div className="hidden lg:block lg:w-[220px] xl:w-[240px] flex-shrink-0">
          <AccountSidebar />
        </div>

        {/* Main Content - Flex-1 and min-w-0 prevents overflow issues */}
        <div className="flex-1 w-full min-w-0">
          <h2 className="text-sm font-bold mb-1 mt-1 text-gray-800">Bet History</h2>

          {/* Filter Section */}
          <div className="bg-white border border-gray-300 rounded shadow-sm mb-4">
            <SectionHeader title="Filter Options" />
            <div className="p-4 bg-white">
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-3 items-end">

                {/* 1. Data Source */}
                <div className="relative w-full">
                  <select
                    id="datasourceSelect"
                    onChange={(e) => onChangeDataType(e.target.value)}
                    className="w-full h-[34px] px-3 text-sm border border-[#ccc] rounded text-[#5c6873] appearance-none focus:outline-none focus:border-[#2789ce]"
                    style={{ background: '#fff url(https://aura444.com/Down-Arrow.696f11d0c8727f3b.svg) right 10px center / 12px no-repeat' }}
                  >
                    <option value="" disabled selected>Data Source</option>
                    <option value="LIVE">LIVE DATA</option>
                    <option value="BACKUP">BACKUP DATA</option>
                    <option value="OLD">OLD DATA</option>
                  </select>
                </div>

                {/* 2. Sport Type */}
                <div className="relative w-full">
                  <select
                    id="sportSelect"
                    onChange={(e) => onChangeSportType(e.target.value)}
                    className="w-full h-[34px] px-3 text-sm border border-[#ccc] rounded text-[#5c6873] appearance-none focus:outline-none focus:border-[#2789ce]"
                    style={{ background: '#fff url(https://aura444.com/Down-Arrow.696f11d0c8727f3b.svg) right 10px center / 12px no-repeat' }}
                    defaultValue="4"
                  >
                    <option value="4">Cricket</option>
                    <option value="2">Tennis</option>
                    <option value="66102">Casino</option>
                    <option value="777">WCO Casino</option>
                    <option value="1">Soccer</option>
                    <option value="7">Horse Racing</option>
                    <option value="4339">Greyhound Racing</option>
                    <option value="27979456">Kabaddi</option>
                    <option value="7522">Basketball</option>
                    <option value="2378961">Politics</option>
                    <option value="66101">Virtual Sports</option>
                    <option value="66104">Lottery</option>
                  </select>
                </div>

                {/* 3. Bet Status */}
                <div className="relative w-full">
                  <select
                    name="betStatus"
                    onChange={(e) => onChangeBetStatus(e.target.value)}
                    className="w-full h-[34px] px-3 text-sm border border-[#ccc] rounded text-[#5c6873] appearance-none focus:outline-none focus:border-[#2789ce]"
                    style={{ background: '#fff url(https://aura444.com/Down-Arrow.696f11d0c8727f3b.svg) right 10px center / 12px no-repeat' }}
                    defaultValue="Settled"
                  >
                    <option value="" disabled>Bet Type</option>
                    <option value="Settled">Settled</option>
                    <option value="void">Void</option>
                    <option value="Open">Unsettled</option>
                  </select>
                </div>

                {/* 4. From Date */}
                <div className="relative w-full">
                  <div className="flex bg-white border border-[#ccc] rounded h-[34px]">
                    <input
                      className="flex-1 px-3 text-sm text-[#555] bg-transparent outline-none cursor-pointer"
                      type="text"
                      value={formattedFromDate}
                      onClick={toggleFromCalendar}
                      readOnly
                      placeholder="From Date"
                    />
                    {/* <button
                      type="button"
                      onClick={toggleFromCalendar}
                      className="w-[34px] bg-[#c8ced2] flex items-center justify-center border-l border-[#ccc] rounded-r"
                    >
                      <svg fill='black' width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 5V8H15V5H9V8H6V5H4V20H20V5H18ZM7 19H5V17H7V19ZM7 16H5V14H7V16ZM7 13H5V11H7V13ZM10 19H8V17H10V19ZM10 16H8V14H10V16ZM10 13H8V11H10V13ZM13 19H11V17H13V19ZM13 16H11V14H13V16ZM13 13H11V11H13V13ZM16 19H14V17H16V19ZM16 16H14V14H16V16ZM16 13H14V11H16V13ZM19 19H17V17H19V19ZM19 16H17V14H19V16ZM19 13H17V11H19V13Z" />
                        <path d="M7 4H8V7H7V4Z" />
                        <path d="M16 4H17V7H16V4Z" />
                      </svg>
                    </button> */}
                  </div>
                  {showFromCalendar && (
                    <div className="absolute z-50 top-[40px] left-0 shadow-lg">
                      <Calendar onChange={handleFromDate} value={new Date(formData.from_date)} calendarType="gregory" />
                    </div>
                  )}
                </div>

                {/* 5. To Date */}
                <div className="relative w-full">
                  <div className="flex bg-white border border-[#ccc] rounded h-[34px]">
                    <input
                      className="flex-1 px-3 text-sm text-[#555] bg-transparent outline-none cursor-pointer"
                      type="text"
                      value={formattedToDate}
                      onClick={toggleToCalendar}
                      readOnly
                      placeholder="To Date"
                    />
                    {/* <button
                      type="button"
                      onClick={toggleToCalendar}
                      className="w-[34px] bg-[#c8ced2] flex items-center justify-center border-l border-[#ccc] rounded-r"
                    >
                      <svg fill='black' width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 5V8H15V5H9V8H6V5H4V20H20V5H18ZM7 19H5V17H7V19ZM7 16H5V14H7V16ZM7 13H5V11H7V13ZM10 19H8V17H10V19ZM10 16H8V14H10V16ZM10 13H8V11H10V13ZM13 19H11V17H13V19ZM13 16H11V14H13V16ZM13 13H11V11H13V13ZM16 19H14V17H16V19ZM16 16H14V14H16V16ZM16 13H14V11H16V13ZM19 19H17V17H19V19ZM19 16H17V14H19V16ZM19 13H17V11H19V13Z" />
                        <path d="M7 4H8V7H7V4Z" />
                        <path d="M16 4H17V7H16V4Z" />
                      </svg>
                    </button> */}
                  </div>
                  {showToCalendar && (
                    <div className="absolute z-50 top-[40px] left-0 shadow-lg">
                      <Calendar onChange={handleToDate} value={new Date(formData.to_date)} calendarType="gregory" />
                    </div>
                  )}
                </div>

                {/* 6. Button */}
                <div className="w-full">
                  <button
                    onClick={filterBetHistory}
                    className="w-full h-[34px] text-sm font-bold text-white rounded-[.25rem] bg-[linear-gradient(-180deg,#474747_0%,#070707_100%)] hover:opacity-90 transition-opacity border border-[#ccc]"
                  >
                    Get History
                  </button>
                </div>

              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="bg-white border border-gray-300 rounded shadow-sm">
            <SectionHeader title="Bet History" />

            <div className='p-4 bg-white'>
              {/* Page Size Control */}
              <div className='flex flex-col md:flex-row justify-between items-center mb-4'>
                <div className='text-[#333] text-sm mb-2 md:mb-0'>
                  <label className='flex items-center'>
                    Show
                    <Select defaultValue={10} onChange={handlePageSizeChange} className='mx-2 w-[70px] h-[34px]'>
                      <Select.Option value={10}>10</Select.Option>
                      <Select.Option value={25}>25</Select.Option>
                      <Select.Option value={50}>50</Select.Option>
                      <Select.Option value={100}>100</Select.Option>
                    </Select>
                    entries
                  </label>
                </div>
              </div>

              {/* Table */}
              <Table
                loading={loading}
                locale={locale}
                columns={columns}
                className='overflow-auto bets-history'
                bordered
                dataSource={paginatedData}
                pagination={false}
                rowKey={(record, index) => index}
                scroll={{ x: true }} // Ensures horizontal scrolling on mobile
              />

              {/* Custom Pagination */}
              <div className='flex flex-col md:flex-row justify-between items-center mt-4 text-[#333] text-sm'>
                <div className='mb-2 md:mb-0'>
                  Showing {filteredData?.length > 0 ? startIndex + 1 : 0} to {Math.min(endIndex, filteredData?.length || 0)} of {filteredData?.length || 0} entries
                </div>
                <div className='flex items-center gap-1'>
                  <button
                    className='px-3 py-1 border border-transparent hover:bg-gray-100 rounded text-[#666] disabled:opacity-50'
                    onClick={handleFirst}
                    disabled={current === 1}
                  >
                    First
                  </button>

                  <Pagination
                    current={current}
                    pageSize={pageSize}
                    total={filteredData?.length || 0}
                    onChange={(page) => setCurrent(page)}
                    showSizeChanger={false}
                    itemRender={(page, type, originalElement) => {
                      if (type === 'prev') return <button className='px-2 hover:text-black'>Previous</button>;
                      if (type === 'next') return <button className='px-2 hover:text-black'>Next</button>;
                      if (type === 'page') return null;
                      return originalElement;
                    }}
                  />

                  <button
                    className='px-3 py-1 border border-transparent hover:bg-gray-100 rounded text-[#666] disabled:opacity-50'
                    onClick={handleLast}
                    disabled={current === Math.ceil((filteredData?.length || 0) / pageSize)}
                  >
                    Last
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BetHistory;